'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import unescapedText from 'I18n/utils/unescapedText';
import { getAppCategoryI18nKey, getCategoryFeatureI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import { getHubSpotFeatureGroupI18nKey, getHubSpotFeatureI18nKey, getTierI18nKey } from 'marketplace-ui-common/utils/i18n';
import PropTypes from 'prop-types';
import * as CustomPropTypes from '../../../constants/PropTypes';
import * as FilterKey from '../../../constants/search/FilterKey';
import { getDataSyncFilterI18nKey, getPlanTypeFilterI18nKey, getSupportSourceFilterI18nKey } from '../../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterTagText = ({
  activeCategory,
  filterKey,
  value
}) => {
  switch (filterKey) {
    case FilterKey.CATEGORY_V2:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.category.tagText",
        options: {
          value: unescapedText(getAppCategoryI18nKey(value))
        }
      });
    case FilterKey.CATEGORY_FEATURES:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.categoryFeatures.tagText",
        options: {
          value: unescapedText(getCategoryFeatureI18nKey(activeCategory, value))
        }
      });
    case FilterKey.PRICING:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.planType.tagText",
        options: {
          value: unescapedText(getPlanTypeFilterI18nKey(value))
        }
      });
    case FilterKey.PLAN_COMPATIBLE:
    case FilterKey.TIERS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.compatibility.tagText",
        options: {
          value: unescapedText(filterKey === FilterKey.PLAN_COMPATIBLE ? 'appMarketplace.storefront.filters.compatibility.myPlan' : getTierI18nKey(value))
        }
      });
    case FilterKey.HUBSPOT_FEATURES:
      {
        const featureGroup = value.split('_')[0];
        if (isValidI18nKey(getHubSpotFeatureGroupI18nKey(featureGroup))) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "appMarketplace.storefront.filters.hubspotFeatures.tagText",
            options: {
              value: unescapedText(getHubSpotFeatureI18nKey(value)),
              featureGroup: unescapedText(getHubSpotFeatureGroupI18nKey(featureGroup))
            }
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.storefront.filters.hubspotFeatures.tagText_default",
          options: {
            value: unescapedText(getHubSpotFeatureI18nKey(value))
          }
        });
      }
    case FilterKey.INTEGRATIONS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.integrations.tagText",
        options: {
          value
        }
      });
    case FilterKey.CREDENTIALS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.certified.tagText"
      });
    case FilterKey.SYNC:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.sync.tagText",
        options: {
          value: unescapedText(getDataSyncFilterI18nKey(value))
        }
      });
    case FilterKey.APP_LANGUAGES:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.appLanguages.tagText",
        options: {
          value: unescapedText(`SharedI18nStrings.languageNames.${value}`)
        }
      });
    case FilterKey.SUPPORT_LANGUAGES:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.supportedLanguages.tagText",
        options: {
          value: unescapedText(`SharedI18nStrings.languageNames.${value}`)
        }
      });
    case FilterKey.SUPPORT_SOURCE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.supportSource.tagText",
        options: {
          value: unescapedText(getSupportSourceFilterI18nKey(value))
        }
      });
    default:
      return null;
  }
};
FilterTagText.propTypes = {
  activeCategory: CustomPropTypes.category,
  filterKey: PropTypes.oneOf(Object.values(FilterKey)).isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired
};
export default FilterTagText;